// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__mGARl","dot":"index_dot__LtAbf","glow":"index_glow__j5pUq"};